import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageContainerWrapper, EditEmailForm } from '../../../../components';
import { backToPage } from '../../../../utils';
import { useTranslation } from 'react-i18next';
import { editEmailMessageBreadcrumb } from '../../../../services/Columns';
import { accessRoute } from '../../../../routes/EmailSetting';
import useSubmit from '../../../../hooks/useSubmit.hook';
import {
  editEmailService,
  viewEmailService,
} from '../../../../services/EmailMessage/emailTemplate.service';

function EditEmail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const breadcrumb = editEmailMessageBreadcrumb();
  const redirectUrl = accessRoute.EMAIL_TEMPLATES.path;

  const [onSubmit, data, isLoading] = useSubmit({
    service: editEmailService,
    detailsService: viewEmailService,
    id,
    afterSubmitActionType: 'redirect',
    redirectUrl,
  });
  return (
    <div className="wide-md mx-auto">
      <PageContainerWrapper
        breadcrumb={breadcrumb}
        btnArray={['extraButton']}
        extraBtnText={t('text.common.back')}
        extraBtnClass="btn btn-outline-light bg-white"
        onExtraButtonHandleShow={() => backToPage(navigate, redirectUrl)}
        heading={t('text.emailMessage.editEmailTemplates')}
      >
        <div className="nk-block">
          <div className="card">
            <div className="card-inner">
              <EditEmailForm
                formData={data}
                isLoading={isLoading}
                onSubmit={onSubmit}
                backToPage={() => backToPage(navigate, redirectUrl)}
              />
            </div>
          </div>
        </div>
      </PageContainerWrapper>
    </div>
  );
}

export default EditEmail;
